// Circular progress component used for in-progress queue cards.
import RadialProgress from "global/components/RadialProgress";



// Render queued/running jobs as collapsed bars or expanded cards.
const InProgressQueueSection = ({
  isInProgressCollapsed,
  setIsInProgressCollapsed,
  totalInProgressCount,
  inProgressJobBarsLayout,
  inProgressJobBarsRef,
  hiddenInProgressCount,
  inProgressRowRef,
  inProgressQueueItems,
  inProgressDisplayItems,
  getQueueItemIdentity,
  getQueueItemProgressValue,
  getQueueItemProgressColor,
  getWorkflowTitleForQueueItem,
  getQueueItemPromptDisplay,
  onOpenFocusImage,
  onDeleteImage,
}) => {

  return (

    <section className={`ai-in-progress-section ${isInProgressCollapsed ? "ai-in-progress-section--collapsed" : ""}`}>

      <div className="ai-in-progress-header">

        {/* Section heading + total count of active queued/running jobs. */}
        <h3>
          In-Progress Queue
          <span className="ai-in-progress-count">({totalInProgressCount})</span>
        </h3>

        {isInProgressCollapsed && (

          /* Collapsed mode shows compact per-job progress bars. */
          <div
            className={`ai-in-progress-job-bars ${inProgressJobBarsLayout.hiddenCount > 0 ? "ai-in-progress-job-bars--full" : ""}`}
            ref={inProgressJobBarsRef}
          >

            {inProgressJobBarsLayout.visibleJobs.map((job) => (

              <div
                key={job.key}
                className={`ai-in-progress-job-bar ${job.phase === "queued" ? "ai-in-progress-job-bar--queued" : "ai-in-progress-job-bar--running"}`}
                title={`Job ${job.key}: ${job.progress}% (${job.phase === "queued" ? "Queued" : "In progress"})`}
              >

                <div
                  className={`ai-in-progress-job-bar__fill ${job.phase === "queued" ? "ai-in-progress-job-bar__fill--queued" : "ai-in-progress-job-bar__fill--running"}`}
                  style={{ width: `${job.progress}%` }}
                >

                </div>

              </div>

            ))}

            {inProgressJobBarsLayout.hiddenCount > 0 && (

              <div className="ai-in-progress-job-bars__more">

                +{inProgressJobBarsLayout.hiddenCount} more

              </div>

            )}

          </div>

        )}

        {/* Expand/collapse control for switching between bar view and card list view. */}
        <button
          type="button"
          className="ai-in-progress-toggle"
          onClick={() => setIsInProgressCollapsed((previous) => !previous)}
          aria-expanded={!isInProgressCollapsed}
          aria-label={isInProgressCollapsed ? "Show in-progress queue" : "Hide in-progress queue"}
          title={isInProgressCollapsed ? "Show queue" : "Hide queue"}
        >

          {isInProgressCollapsed ? "v" : "^"}

        </button>

      </div>

      {!isInProgressCollapsed && (

        /* Expanded mode shows interactive queue cards with prompt/workflow metadata. */
        <div
          className={`ai-in-progress-row ${hiddenInProgressCount > 0 ? "ai-in-progress-row--overflow" : ""}`}
          ref={inProgressRowRef}
        >

          {/* Empty state when there are no queued/running jobs. */}
          {inProgressQueueItems.length === 0 ? (

            <div className="ai-in-progress-empty">

              No in-progress items.

            </div>

          ) : (

            /* Render each visible in-progress item as a compact interactive card. */
            inProgressDisplayItems.map((img) => (

              <div
                key={`in-progress-${getQueueItemIdentity(img)}`}
                className="ai-in-progress-item"
              >

                <div
                  className="ai-image-skeleton ai-image-skeleton--compact ai-in-progress-clickable"
                  onClick={() => onOpenFocusImage(img)}
                >

                  <div className="ai-image-buttons">

                    <button
                      type="button"
                      title="Delete Image"
                      className="ai-image-focus-button ai-delete-button tooltip tooltip-bottom"
                      data-tip="Delete Image"
                      onClick={(event) => {

                        event.stopPropagation();

                        onDeleteImage(img.job);

                      }}
                    >

                      <svg width="32" height="32" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="20" y="12" width="24" height="4" fill="white" />
                        <rect x="26" y="8" width="12" height="4" fill="white" />
                        <rect x="16" y="16" width="32" height="36" stroke="white" strokeWidth="2" fill="none" rx="2" />
                        <line x1="24" y1="22" x2="24" y2="46" stroke="white" strokeWidth="2" />
                        <line x1="32" y1="22" x2="32" y2="46" stroke="white" strokeWidth="2" />
                        <line x1="40" y1="22" x2="40" y2="46" stroke="white" strokeWidth="2" />
                        <line x1="48" y1="8" x2="56" y2="16" stroke="white" strokeWidth="2" strokeLinecap="round" />
                        <line x1="56" y1="8" x2="48" y2="16" stroke="white" strokeWidth="2" strokeLinecap="round" />
                      </svg>

                    </button>

                  </div>

                  {/* Center progress area with radial status ring and metadata. */}
                  <div className="ai-in-progress-progress-content">

                    <div className="ai-image-progress-circle">

                      <RadialProgress
                        value={getQueueItemProgressValue(img)}
                        direction={"clockwise"}
                        size={108}
                        progressColor={getQueueItemProgressColor(img)}
                        bgColor={"var(--input-border, #b3b3b3)"}
                      />

                      <div className="ai-image-progress-text">

                        <div>{img.status}</div>

                        <div>{img.run_by}</div>

                      </div>

                    </div>

                  </div>

                  {/* Workflow name gives context even before output is ready. */}
                  <p className="ai-image-skeleton-workflow-title">

                    {getWorkflowTitleForQueueItem(img) || "Workflow"}

                  </p>

                  {/* Prompt preview helps identify the queued/running job. */}
                  <div className="ai-in-progress-details">

                    <div className="prompt">{getQueueItemPromptDisplay(img) || "No prompt available."}</div>

                  </div>

                </div>

              </div>

            ))

          )}

          {hiddenInProgressCount > 0 && (

            <div className="ai-in-progress-more">+{hiddenInProgressCount} items</div>

          )}

        </div>

      )}

    </section>

  );

};

export default InProgressQueueSection;
